import { render } from "./TicketDetails.vue?vue&type=template&id=2cbd66cc&scoped=true"
import script from "./TicketDetails.vue?vue&type=script&lang=js"
export * from "./TicketDetails.vue?vue&type=script&lang=js"

import "./TicketDetails.vue?vue&type=style&index=0&id=2cbd66cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbd66cc"],['__file',"src/views/TicketDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cbd66cc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cbd66cc', __exports__)) {
    api.reload('2cbd66cc', __exports__)
  }
  
  module.hot.accept("./TicketDetails.vue?vue&type=template&id=2cbd66cc&scoped=true", () => {
    api.rerender('2cbd66cc', render)
  })

}


export default __exports__